<div>
  <h4>Replication for this S3 bucket needs to be configured.</h4>
</div>
<div class="margin-top">
  {{ uiService.productName }} will create a clone of this bucket in the recovery environment and optionally replicate
  its contents.
</div>
<form [formGroup]="bucketConfigFormModel" (ngSubmit)="saveClick()" class="form-controls">
  <div>
    <div class="control-header-with-instructions">
      <h4 class="spacer">How should {{ uiService.productName }} recover this bucket?</h4>
    </div>
    <div class="arpio-radio-container">
      <div class="margin-top"></div>
      <label class="arpio-radio">
        <input id="object-replication-mode" type="radio" formControlName="objectReplicationMode" value="none" />
        <span class="radio-label strong-text"> Recover the bucket but not its contents</span>
        <div>
          Choose this option for buckets containing ephemeral data or data that is not relevant in the recovery
          environment (such as logs). A clone of this bucket will be created in the recovery environment but
          {{ uiService.productName }} will not manage its contents.
        </div>
      </label>
      <div class="margin-top"></div>
      <label class="arpio-radio">
        <input id="object-replication-mode" type="radio" formControlName="objectReplicationMode" value="realTime" />
        <span class="radio-label strong-text"> Recover the bucket and its contents </span>
        <div>
          Choose this option for buckets containing persisted application data. A clone of this bucket will be created
          in the recovery environment and objects in this bucket will be replicated into the cloned bucket via
          <a target="_blank" href="{{ uiService.s3BucketReplicationDocs }}">S3 bucket replication</a>.
        </div>
      </label>
      <ng-container *ngIf="objectReplicationMode == 'realTime'">
        <div class="nested-content">
          <div class="control-header-with-instructions">
            <h4 class="spacer">How should we configure bucket replication?</h4>
          </div>
          <div class="arpio-radio-container">
            <div class="margin-top"></div>
            <label class="arpio-radio">
              <input
                id="customer-manages-replication"
                type="radio"
                formControlName="customerManagesReplication"
                value="false"
              />
              <span class="radio-label strong-text"> Let {{ uiService.productName }} configure bucket replication</span>
              <div>
                Select this option if you do not manage the primary environment S3 bucket with an infrastructure as code
                solution (such as Terraform or CloudFormation).
              </div>
            </label>
            <div class="margin-top"></div>
            <label class="arpio-radio">
              <input
                id="customer-manages-replication"
                type="radio"
                formControlName="customerManagesReplication"
                value="true"
              />
              <span class="radio-label strong-text"> I'll configure bucket replication myself</span>
              <div>
                Select this option if you manage the primary environment resources with an infrastructure as code
                solution. After the next recovery point attempt, Arpio will create a new issue here with the details and
                instructions for configuring bucket replication yourself.
              </div>
            </label>
          </div>
          <div class="flex-bottom-row">
            <div class="full-width">
              <div class="flex-center-row control-header-with-instructions">
                <h4 class="spacer">Objects To Backfill</h4>
                <h4>{{ backfillRangeText }}</h4>
              </div>
              <div class="control-header-instructions">
                Specify the timeframe of objects to backfill into this new bucket.
              </div>
              <input
                id="back-fill-range"
                class="full-width"
                type="range"
                min="0"
                [max]="backfillOptions.length - 1"
                formControlName="backfillRange"
              />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="snapshotModeEnabled">
        <div class="margin-top"></div>
        <label class="arpio-radio">
          <input id="object-replication-mode" type="radio" formControlName="objectReplicationMode" value="snapshot" />
          <span class="radio-label strong-text"> Recover the bucket and snapshot its contents </span>
          <div>
            Choose this option if it is important that your recovered bucket match the contents of your primary bucket
            at the time the recovery point was created. The data will be replicated to your recovery account and region
            and snapshots of that bucket will be included in your recovery point.
          </div>
        </label>
      </ng-container>
    </div>
  </div>
  <div class="flex-center-row control-header">
    <div class="spacer"></div>
    <button type="submit" class="arpio-button" [disabled]="!validConfig">
      <ng-container [ngSwitch]="saveStatus">
        <i *ngSwitchCase="'saving'" class="fa-solid fa-spinner fa-spin"></i>
        <i *ngSwitchCase="'saved'" class="fa-utility fa-semibold fa-check"></i>
        <ng-container *ngSwitchDefault>SAVE</ng-container>
      </ng-container>
    </button>
  </div>
</form>

<modal-dialog #ConfirmManualReplicationConfigDialog [dialogTemplate]="confirmManualReplicationConfig"></modal-dialog>
<ng-template #confirmManualReplicationConfig>
  <div class="flex-center-column full-width">
    <div class="dialog light-content-panel double-margin-top">
      <div class="flex-center-row">
        <h3 class="panel-title">Configuring Bucket Replication</h3>
      </div>

      <div class="margin-top">
        You're choosing to configure replication yourself. Here's what happens next:
        <ol>
          <li>
            {{ uiService.productName }} will create a new bucket in the recovery environment if it doesn't already
            exist.
          </li>
          <li>
            {{ uiService.productName }} will create an IAM role in the production environment with minimal permissions
            to replicate objects to the recovery environment bucket.
          </li>
          <li>
            {{ uiService.productName }} will create a new issue in this console with the details necessary for you to
            configure replication yourself.
          </li>
        </ol>
        When you see the new issue here in Arpio it will be time to configure replication. Hang tight until then.
      </div>
      <div class="flex-center-row double-margin-top full-width">
        <div class="spacer"></div>
        <button type="button" class="arpio-secondary-button" (click)="dialogCancelClick()">CANCEL</button>
        <button type="button" class="arpio-button margin-left" (click)="dialogContinueClick()">CONTINUE</button>
        <div class="spacer"></div>
      </div>
    </div>
  </div>
</ng-template>
